import React, { FC } from "react";

import images from "../../../assets/png/travel1.png";

import styles from "./styles.module.css";
import { useNavigate } from "react-router-dom";

interface Props {
  item: any;
}

const BrowseCard: FC<Props> = ({ item }) => {
  const navigate = useNavigate();
  return (
    <div
      className={styles.card}
      onClick={() => navigate(`/details/${item.listing_id}`)}
    >
      <img
        src={
          item.used_listing_pictures[0]
            ? item.used_listing_pictures[0].picture_url
            : images
        }
        alt=""
      />
      <div>
        <div className={styles.title}>
          <p style={{ fontSize: '1.2em', fontWeight: 'semibold', marginBottom: '8px' }}>
            {item.city}, {item.country}, {item.district}
          </p>
          <p>
            {item.description?.slice(0, 100)}
            {item.description?.length > 100 ? '...' : ''}
          </p>
          {item.check_in && item.check_out && (
            <p>Approx dates: {item.check_in.split('T')[0]} - {item.check_out.split('T')[0]}</p>
          )}
          <p>Cost: {item.price?.slice(0, 40)}</p>
        </div>
      </div>
    </div>
  );
};

export default BrowseCard;
